import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CheckboxGroup } from './styled';
var Checkboxes = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, onChange = _a.onChange, _c = _a.value, value = _c === void 0 ? [] : _c;
    return (_jsx(CheckboxGroup, { options: options, onChange: onChange, value: value }));
};
export default Checkboxes;
